import { render, staticRenderFns } from "./PaymentDetailSDDB2B.vue?vue&type=template&id=1f3aafae&"
import script from "./PaymentDetailSDDB2B.vue?vue&type=script&lang=js&"
export * from "./PaymentDetailSDDB2B.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports